module.exports = __webpack_public_path__ + "media/arbutin-medium.2e10249f.mp4";